import { SOCIAL_SECURITY_PROFILE } from '../action-types'

export default (
    state = {
        fetchSuccessful: null,
        shouldFetch: true,
        data: {},
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case SOCIAL_SECURITY_PROFILE.REQUEST: {
            return { ...state, shouldFetch: false }
        }
        case SOCIAL_SECURITY_PROFILE.RECEIVE: {
            return { ...state, ...data }
        }
        default:
            return state
    }
}
